<template>
    <div>
        <DetailHeader
            title="Retail Company Gains Cloud Security and High-performance SaaS Access with SD-WAN"
            subTitle="A large retail company solves the vexing complexity inherent in security, cloud resource access, and cloud application performance by going with a cloud-delivered, hosted management and gateway SD-WAN solution. Zscaler security integration became a cinch, VPN tunnels were reduced from 2500 to 5, and application access directly over branch office Internet links to cloud locations was optimized by leveraging cloud-based gateways."
        />
        <DetailBody>
            <p class="reveal-bottom">
                dfsdf dfsd fdf s sdf d fds sdf dsfs fsf dfs fdsf dsfsdf sfsdfdsf
                dsf sdfds A large retail company solves the vexing complexity
                inherent in security, cloud resource access, and cloud
                application performance by going with a cloud
            </p>
            <h3 class="reveal-bottom">WAN Challenges</h3>
            <p class="reveal-bottom">
                dfsdf dfsd fdf s sdf d fds sdf dsfs fsf dfs fdsf dsfsdf sfsdfdsf
                dsf sdfds A large retail company solves the vexing complexity
                inherent in security, cloud resource access, and cloud
                application performance by going with a cloud
            </p>
            <h3 class="reveal-bottom">WAN Challenges</h3>
            <p class="reveal-bottom">
                dfsdf dfsd fdf s sdf d fds sdf dsfs fsf dfs fdsf dsfsdf sfsdfdsf
                dsf sdfds A large retail company solves the vexing complexity
                inherent in security, cloud resource access, and cloud
                application performance by going with a cloud
            </p>
            <p class="reveal-bottom">
                dfsdf dfsd fdf s sdf d fds sdf dsfs fsf dfs fdsf dsfsdf sfsdfdsf
                dsf sdfds A large retail company solves the vexing complexity
                inherent in security, cloud resource access, and cloud
                application performance by going with a cloud dfsdf dfsd fdf s
                sdf d fds sdf dsfs fsf dfs fdsf dsfsdf sfsdfdsf dsf sdfds A
                large retail company solves the vexing complexity inherent in
                security, cloud resource access, and cloud application
                performance by going with a cloud dfsdf dfsd fdf s sdf d fds sdf
                dsfs fsf dfs fdsf dsfsdf sfsdfdsf dsf sdfds A large retail
                company solves the vexing complexity inherent in security, cloud
                resource access, and cloud application performance by going with
                a cloud dfsdf dfsd fdf s sdf d fds sdf dsfs fsf dfs fdsf dsfsdf
                sfsdfdsf dsf sdfds A large retail company solves the vexing
                complexity inherent in security, cloud resource access, and
                cloud application performance by going with a cloud
            </p>
        </DetailBody>
    </div>
</template>
<script>
import DetailHeader from "./DetaiHeader";
import DetailBody from "./DetailBody";
import initAnimation from "../animation"
export default {
    name: "CustomerDetail",
    data() {
        return {
            back: 12,
        };
    },
    mounted(){
        setTimeout(initAnimation,0);
    },
    components: {
        DetailHeader,
        DetailBody,
    },
};
</script>



// WEBPACK FOOTER //
// src/Pages/CustomerDetail/CustomerDetail.vue